import { render, staticRenderFns } from "./VPlusWidget.vue?vue&type=template&id=7234aab5&"
import script from "./VPlusWidget.vue?vue&type=script&lang=ts&"
export * from "./VPlusWidget.vue?vue&type=script&lang=ts&"
import style0 from "./VPlusWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports